// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1aW2W","dragIcon":"Choice_dragIcon__1SbKk","left":"Choice_left__3tw6Q","input":"Choice_input__92dfW"};